import { scroll, inView } from "motion";

const Process = (parent) => {
  const wrapper = parent.querySelector(".process-wrapper");
  const children = parent.querySelectorAll(".giantpeach-processtile");
  const yAxis = parent.querySelector('.y-axis-anim');

  scroll(
    (progress, info) => {
      yAxis.style.transform = "scaleY(" + progress.y.progress + ")";
    },
    {
      target: wrapper,
      offset: ["start center", "end center"],
    },
  );

  children.forEach((child) => {
    let observer;

    inView(
      child,
      (info) => {
        child.classList.add("active");

        return (_) => {
          child.classList.remove("active");
        };
      },
      {
        margin: `0px 0px -${parseInt(window.innerHeight / 2)}px 0px`,
      },
    );
  });
};

export default Process;
